import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { I18NextModule } from 'angular-i18next';
import { PrimengModule } from 'src/app/primeng/primeng.module';
import { MxDropdownComponent } from './mx.dropdown.component';

export const COMPONENTS: any[] = [MxDropdownComponent];

@NgModule({
  imports: [CommonModule, PrimengModule, FormsModule, I18NextModule],
  declarations: [...COMPONENTS],
  exports: [...COMPONENTS],
})
export class MxDropdownModule {}
